module.exports = __webpack_public_path__ + "img/slider1.796b1d80.jpg";